import classNames from "classnames";
import CardTitle from "../../../components/CardTitle";
import TMapComp from "../../../components/TMap";
import styles from "./WisdomPartyBuilding.module.scss";
import styled from "@emotion/styled";
import { Modal, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { MainLayout } from "../../../components/Layout";
import { useCallback, useEffect, useRef, useState } from "react";
import request from "../../../utils/request";
import cardInfoBg from "../../../images/card-box6.png";
import DialogItemImg1 from "../../../images/modal-card1.png";
import { Project } from "./Modals/Project";
import { LiveTime } from "../../../components/LiveTime/index";
import { CommonModal } from "./Modals/Common/CommonModal";
import YearPicker from "../../../components/YearPicker";
import { SwiperTable } from "../../../components/SwiperTable";
// import { CommonModal } from "./Modals/Common/CommonModal";
const ProjectConstructionLayout = styled.div`
  .card-infos {
    display: flex;
    flex-wrap: wrap;
    li {
      list-style: none;
    }
  }
  .card-info {
    width: 215px;
    height: 119px;
    margin-bottom: 13px;
    background-image: url(${cardInfoBg}) !important;
    strong {
      font-size: 26px;
      font-weight: 800;
    }
    .label {
      margin-top: 15px;
      font-size: 15px;
      color: #fff;
      text-align: center;
      padding: 0 10px;
    }
    .unit {
      transform: translateY(-2px);
      margin-left: 15px;
      font-size: 15px;
      color: #fff;
    }
  }
  .card-info2 {
    width: 172px;
    height: 86px;
    margin-bottom: 30px;
  }
  .common-box {
    padding: 0 15px;
  }
  .ant-modal .ant-modal-content {
    background-color: transparent;
  }
  .dialog-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
  }
  .dialog-item1 {
    width: 1545px;
    min-height: 447px;
    /* background-size: contain;
    background-image: url(${DialogItemImg1});
    background-repeat: no-repeat; */
  }
  .dialog-item2 {
    width: 1545px;
    min-height: 513px;
    margin-top: 20px;
  }
  .ant-modal-wrap {
    z-index: 99999999999;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-close {
    color: #fff;
    top: 54px;
    right: -40px;
    width: 50px;
    height: 50px;
    .ant-modal-close-x {
      font-size: 30px !important;
    }
  }
  .ant-modal .ant-modal-close:hover {
    color: #fff;
  }
`;

const ProjectConstruction: React.FC = () => {
  const [leftData, setLeftData] = useState<any[]>([]);
  const [projects, setProjects] = useState<any[]>([]);
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  );
  const projectName = useRef("");
  const [visible, setVisible] = useState(false);
  const parentRef = useRef<any>(null);
  const [currentProject, setCurrentProject] = useState<any>();
  const getProjectInfo = useCallback(async () => {
    try {
      const url = currentYear
        ? "/screen/Index/getProjectInfo?years=" + currentYear
        : "/screen/Index/getProjectInfo";
      const res = await request.get(url);
      setLeftData(res.data.data);
    } catch (e) {}
  }, [currentYear]);

  const getProjects = useCallback(async () => {
    try {
      const res = await request.get(
        `/screen/Index/getProject?keys=${projectName.current}`
      );
      const data = res?.data?.data.map((item: any) => {
        return {
          ...item,
        };
      });

      setProjects(data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    getProjectInfo();
    getProjects();
  }, [getProjectInfo, getProjects]);

  const columns: ColumnsType<any> = [
    {
      title: "项目名称",
      dataIndex: "name",
      align: "center",
    },
    {
      title: "开工时间",
      align: "center",
      dataIndex: "startdate",
      colSpan: 5,
      render(value) {
        if (value) return value;
        return " 2023-02-23";
      },
    },
    {
      title: "竣工时间",
      align: "center",
      dataIndex: "completiondate",
      colSpan: 5,
      render(value) {
        if (value) return value;
        return " 2023-02-23";
      },
    },
  ];
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const [param, setParam] = useState({} as any);
  const [title, setTitle] = useState("");

  const goDetail = (record: any) => {
    setOpen(false);
    setCurrentProject(record?.id);
    setVisible(true);
  };
  return (
    <ProjectConstructionLayout>
      <div className={styles.commonBox}>
        <div className={styles.WisdomPartyBuilding} ref={parentRef}>
          <LiveTime />
          <MainLayout
            leftWidth={495}
            left={
              <div>
                <div className={classNames(styles.flex, styles.cardTitle)}>
                  <CardTitle
                    titleStyles={{
                      paddingLeft: 65,
                    }}
                    title="项目总览"
                  />
                  <YearPicker
                    defaultValue={currentYear}
                    onChange={(e, dateStr) => {
                      setCurrentYear(dateStr);
                    }}
                  />
                </div>
                <div className="left-content">
                  <ul className="card-infos">
                    {leftData.map((item, index) => {
                      return (
                        <li
                          key={index}
                          style={{
                            cursor: [1].includes(index) ? "default" : "pointer",
                          }}
                          onClick={() => {
                            if (![1].includes(index)) {
                              setOpen(true);
                              setParam({
                                type: index,
                                years: currentYear,
                                goDetail: goDetail,
                                // page: 1,
                              });
                              // https://apiv2.wxstores.cn/screen/Index/getProjects?type=2&years=2022&page=1&keys=
                              setType("getProjects");
                              setTitle(item.title);
                            }
                          }}
                          className={classNames(
                            "card-info",
                            styles.cardInfo,
                            styles.envCard
                          )}
                        >
                          <div key={index}>
                            <div
                              className={classNames(
                                styles.flex,
                                styles.flexCenter
                              )}
                              style={{ marginTop: 14, alignItems: "flex-end" }}
                            >
                              <strong
                                style={{
                                  color: "#41FF5C",
                                }}
                              >
                                {item.val}
                              </strong>
                              <span className="unit">{item.unit}</span>
                            </div>
                            <p className="label">{item.title}</p>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            }
            rightWidth={680}
            right={
              <div>
                <CardTitle
                  titleStyles={{
                    paddingLeft: 65,
                  }}
                  title="项目列表"
                />

                <div className="common-box">
                  <div
                    className={styles.inputWrapper}
                    style={{ marginTop: 18 }}
                  >
                    <input
                      type="text"
                      placeholder="请输入项目名称"
                      onChange={(e) => {
                        projectName.current = e.target.value;
                      }}
                    />
                    <button
                      className={styles.searchBtn}
                      onClick={() => {
                        getProjects();
                      }}
                    >
                      搜索
                    </button>
                  </div>
                  <div className={styles.tableBox} style={{ marginTop: 28 }}>
                    {/* <Table
                      className={styles.table}
                      columns={columns}
                      dataSource={projects}
                      pagination={false}
                    /> */}
                    <SwiperTable
                      columns={columns}
                      slidesHeight={600}
                      slidesPerView={9}
                      dataSource={projects}
                    />
                  </div>
                </div>
              </div>
            }
            map={
              <TMapComp
                isFullScreen
                geometry={projects
                  .filter((item) => !!item.gisdata)
                  .map((item) => item.gisdata)}
                textTag={projects
                  .filter((item) => !!item.position)
                  .map((item) => {
                    return {
                      id: item.id,
                      name: item.name,
                      position: item.position
                        .split(",")
                        .map((item: string) => Number(item)),
                    };
                  })}
                onGeometryClick={(data) => {
                  console.log("data", data);
                  // setCurrentProject(299);
                  setCurrentProject(data?.id);
                  setVisible(true);
                }}
              />
            }
          >
            <Modal
              open={visible}
              getContainer={() => {
                // return null;
                return parentRef.current!;
              }}
              width={1545}
              onCancel={() => {
                setVisible(false);
              }}
            >
              <div className="dialog-item dialog-item1">
                {/* <ProjectModel id={currentProject} /> */}
                <Project id={currentProject} type={"getProjectDetails"} />
              </div>
              {/* {modalContent} */}
              {/* 22222 */}
            </Modal>
            <CommonModal
              type={type}
              visible={open}
              setVisible={setOpen}
              param={param}
              title={title}
            />
          </MainLayout>
        </div>
      </div>
    </ProjectConstructionLayout>
  );
};

export default ProjectConstruction;
